import { BorderTop } from "@mui/icons-material";
import { keyframes, styled } from "@mui/material/styles";
import zIndex from "@mui/material/styles/zIndex";
import { fontSize } from "suneditor/src/plugins";

const scrollLeftToRight = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(-100%); }
`;

export const ScrollingContent = styled("div")({
  color: "green",
  overflow: "visible", // FIXED
  width: "100%",
  position: "relative",
});

// 🔥 MAIN FIX: No clipping, no flex, no overflow issues
export const StyledTableContainer = styled("div")({
  width: "100%",
  background: "#fff",
  borderRadius: "6px",
  border: "1px solid rgba(0, 0, 0, 0.09)",
  boxShadow: "0px 0px 15px rgb(0 0 0 / 10%)",
  marginBottom: "45px",
  position: "relative",

  // Important: let the table expand
  display: "block",
  overflow: "visible !important",
});

export const StyledTableCollasible = styled("table")(({ theme }) => ({
  width: "100%",
  borderCollapse: "collapse",
  background: "#FFFFFF",
  fontFamily: "muli_regular",

  paddingBottom: "0px", // FIXED

  "& thead": {
    position: "sticky",
    top: 30,
    background: "white",
    zIndex: 3,
  },
  "& tr": {
    cursor: "pointer",
  },
  "& th": {
    color: "grey",
    fontFamily: "muli_regular",
    fontSize: 14,
    padding: "10px",
    textAlign: "left",
  },
  "& td": {
    textAlign: "left",
    padding: "10px",
  },
  "& tbody tr:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledTable = styled("table")(({ theme }) => ({
  width: "100%",
  borderCollapse: "collapse",
  background: "#FFFFFF",
  fontFamily: "muli_regular",

  paddingBottom: "0px", // FIXED

  "& thead": {
    position: "sticky",
    top: 0,
    background: "white",
    // above row checkboxes (MUI checkbox input has zIndex 1) and sticky tfoot (2)
    zIndex: 3,
  },
  "& tr": {
    cursor: "pointer",
  },
  "& th": {
    color: "grey",
    fontFamily: "muli_regular",
    fontSize: 14,
    padding: "10px",
    textAlign: "left",
  },
  "& td": {
    textAlign: "left",
    padding: "10px",
  },
  "& tbody tr:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "& tfoot td": {
    position: "sticky",
    bottom: 0,
    backgroundColor: "#f8f3f3ff",
    zIndex: 2,
    fontWeight: 600,
    border: "2px solid rgba(241, 242, 234, 0.62)",
    boxShadow: "0 -4px 6px -2px rgba(236, 234, 234, 0.08)",

  },



}));

export const StyledTableLoader = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  background: "rgba(255,255,255, 0.4)",
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});
